import React, { FC } from 'react';
import { Button } from '../../atoms';
import BaseTemplate from '../BaseTemplate';
import styles from './LandscapeUpdatesTemplate.module.css';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeUpdatesOrganism } from '../../organisms';
import LandscapeBaseTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';

export interface LandscapeUpdatesTemplateProps {
  stories: StoryResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeUpdatesTemplate: FC<LandscapeUpdatesTemplateProps> = ({
  stories,
  handleDelete,
  handleEdit,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseTemplate>
          <div className={styles.button}>
            <Button
              variant="dark"
              onClick={() =>
                navigate(`/landscapes/edit/${id}/updates/story/add`)
              }
            >
              Add Story
            </Button>
          </div>
          <LandscapeUpdatesOrganism
            data={stories}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </LandscapeBaseTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeUpdatesTemplate;
